import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonLoading,
  IonPage,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonSkeletonText,
  IonText,
  IonToast,
} from "@ionic/react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { downloadOutline } from "ionicons/icons";
import React, { useEffect, useRef, useState } from "react";
import { AuthContext } from "../../providers/authContext";
import raporService from "../../services/RaporService";
import sorgulamaService from "../../services/SorgulamaService";
import BinaDeger from "../entities/BinaDeger";
import BinaInsaatSinif from "../entities/BinaInsaatSinif";
import BinaKullanimSekli from "../entities/BinaKullanimSekli";
import BinaDegerFilter from "../entities/sorgu/BinaDegerFilter";
import "./Page.css";
import Header from "../../components/Header";

const BinaDegerSorgu: React.FC = () => {
  const { setTitle } = React.useContext(AuthContext);
  const [sonuc, setSonuc] = useState<BinaDeger[]>([]);
  const dt = useRef<any>(null);
  const loadingData = [
    { kullanimSekli: "", insaatSinifi: "", insaatTuru: "", maliyetBedeli: 0 },
    { kullanimSekli: "", insaatSinifi: "", insaatTuru: "", maliyetBedeli: 0 },
    { kullanimSekli: "", insaatSinifi: "", insaatTuru: "", maliyetBedeli: 0 },
    { kullanimSekli: "", insaatSinifi: "", insaatTuru: "", maliyetBedeli: 0 },
    { kullanimSekli: "", insaatSinifi: "", insaatTuru: "", maliyetBedeli: 0 },
  ];
  const [loading, setLoading] = useState<boolean>(false);
  const [showLoading, setShowLoading] = useState<boolean>(true);
  const [yillar, setYillar] = useState<number[]>([]);
  const [yil, setYil] = useState<number>(0);
  const [kullanimSekilleri, setKullanimSekilleri] = useState<
    BinaKullanimSekli[]
  >([]);
  const [kullanimSekliId, setKullanimSekli] = useState<string>();
  const [insaatSiniflari, setInsaatSiniflari] = useState<BinaInsaatSinif[]>([]);
  const [insaatSinifiId, setInsaatSinifi] = useState<string>();
  const [yilMessage, setYilMessage] = useState<string>();
  const [kullanimSekliMessage, setKullanimSekliMessage] = useState<string>();
  const [showToastMessage, setShowToastMessage] = useState<string>();

  React.useEffect(() => {
    setTitle("İnşaat m² Maliyet Değerleri Sorgulama");
    setShowLoading(true);
    sorgulamaService
      .getBinaDegerDonemler()
      .then((data: number[]) => setYillar(data))
      .finally(() => setShowLoading(false));
  }, []);

  useEffect(() => {
    setShowLoading(true);
    setKullanimSekilleri([]);
    setKullanimSekli(undefined);
    setInsaatSiniflari([]);
    setInsaatSinifi(undefined);
    sorgulamaService
      .getBinaKullanimSekilleri(yil)
      .then((data: BinaKullanimSekli[]) => setKullanimSekilleri(data))
      .finally(() => setShowLoading(false));
  }, [yil]);

  useEffect(() => {
    setShowLoading(true);
    setInsaatSiniflari([]);
    setInsaatSinifi(undefined);
    sorgulamaService
      .getBinaInsaatSiniflari(yil, kullanimSekliId!)
      .then((data: BinaKullanimSekli[]) => setInsaatSiniflari(data))
      .finally(() => setShowLoading(false));
  }, [yil, kullanimSekliId]);

  const getBinaDeger = (event: any) => {
    event.preventDefault();
    let errorFound = false;
    setYilMessage(undefined);
    setKullanimSekliMessage(undefined);
    if (yil <= 0) {
      setYilMessage("* Yıl alanını doldurunuz");
      errorFound = true;
    }
    if (!kullanimSekliId) {
      setKullanimSekliMessage("* Kullanım Şekli alanını doldurunuz");
      errorFound = true;
    }
    if (errorFound) {
      return;
    }

    setLoading(true);
    const data = new BinaDegerFilter(yil, kullanimSekliId!, insaatSinifiId);
    sorgulamaService
      .getBinaDegers(data)
      .then((data: BinaDeger[]) => setSonuc(data))
      .finally(() => setLoading(false));
  };

  const formatCurrency = (value: number) => {
    if (!value) {
      value = 0;
    }
    return value.toFixed(2);
  };

  const loadingBodyTemplate = () => {
    return <IonSkeletonText animated />;
  };
  const kullanimSekliBodyTemplate = (rowData: any) => {
    return (
      <IonText className="p-column-content">{rowData.kullanimSekli}</IonText>
    );
  };

  const insaatSinifiBodyTemplate = (rowData: any) => {
    return (
      <IonText className="p-column-content">{rowData.insaatSinifi}</IonText>
    );
  };

  const insaatTuruBodyTemplate = (rowData: any) => {
    return <IonText className="p-column-content">{rowData.insaatTuru}</IonText>;
  };

  const degerBodyTemplate = (rowData: any) => {
    return <IonText>{formatCurrency(rowData.maliyetBedeli)}</IonText>;
  };

  const exportPDF = () => {
    setShowLoading(true);
    raporService
      .insaatMaliyetYazdir(yil, kullanimSekliId!, insaatSinifiId)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "insaatm2maliyet.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        console.log(err);
        setShowToastMessage(err);
      })
      .finally(() => setShowLoading(false));
  };

  const footer = (
    <div
      style={{ textAlign: "end", display: sonuc.length > 0 ? "block" : "none" }}
    >
      <IonButton type="button" color="success" onClick={exportPDF}>
        <IonIcon slot="start" icon={downloadOutline} />
        Yazdır
      </IonButton>
    </div>
  );

  return (
    <IonPage>
      <Header />
      <IonContent fullscreen>
        <IonContent>
          <IonLoading
            isOpen={showLoading}
            onDidDismiss={() => setShowLoading(false)}
            message={"Lütfen Bekleyin..."}
          />
          <IonToast
            isOpen={showToastMessage !== undefined}
            onDidDismiss={() => setShowToastMessage(undefined)}
            message={showToastMessage}
            duration={2000}
            position="top"
          />
          <form
            onSubmit={(e) => {
              getBinaDeger(e);
            }}
          >
            <IonGrid>
              <IonRow>
                <IonCol
                  size="4"
                  offset="0"
                  sizeSm="3"
                  offsetSm="1"
                  className="ion-hide-sm-down"
                >
                  <IonItem className="ion-text-end">
                    <IonLabel>Yıl</IonLabel>
                  </IonItem>
                </IonCol>
                <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                  <IonItem className="ion-hide-sm-up">
                    <IonLabel position="floating">Yıl</IonLabel>
                    <IonSelect
                      name="yilInput"
                      interface="popover"
                      value={yil}
                      onIonChange={(e) => setYil(e.detail.value)}
                    >
                      {yillar &&
                        yillar.map((val, i) => (
                          <IonSelectOption key={i} value={val}>
                            {val}
                          </IonSelectOption>
                        ))}
                    </IonSelect>
                  </IonItem>
                  <IonItem className="ion-hide-sm-down">
                    <IonSelect
                      name="yilInput"
                      interface="popover"
                      value={yil}
                      placeholder="Seçiniz..."
                      onIonChange={(e) => setYil(e.detail.value)}
                    >
                      {yillar &&
                        yillar.map((val, i) => (
                          <IonSelectOption key={i} value={val}>
                            {val}
                          </IonSelectOption>
                        ))}
                    </IonSelect>
                  </IonItem>
                </IonCol>
              </IonRow>
              {yilMessage && (
                <IonRow>
                  <IonCol size="8" offset="4">
                    <IonText color="danger ion-padding-start">
                      {yilMessage}
                    </IonText>
                  </IonCol>
                </IonRow>
              )}
              <IonRow>
                <IonCol
                  size="4"
                  offset="0"
                  sizeSm="3"
                  offsetSm="1"
                  className="ion-hide-sm-down"
                >
                  <IonItem className="ion-text-end">
                    <IonLabel>Kullanım Şekli</IonLabel>
                  </IonItem>
                </IonCol>
                <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                  <IonItem className="ion-hide-sm-up">
                    <IonLabel position="floating">Kullanım Şekli</IonLabel>
                    <IonSelect
                      name="kullanimSekliIdInput"
                      interface="popover"
                      value={kullanimSekliId}
                      onIonChange={(e) => setKullanimSekli(e.detail.value)}
                    >
                      {kullanimSekilleri &&
                        kullanimSekilleri.map((val: BinaKullanimSekli, i) => (
                          <IonSelectOption key={i} value={val.id}>
                            {val.tanim}
                          </IonSelectOption>
                        ))}
                    </IonSelect>
                  </IonItem>
                  <IonItem className="ion-hide-sm-down">
                    <IonSelect
                      name="kullanimSekliIdInput"
                      interface="popover"
                      value={kullanimSekliId}
                      placeholder="Seçiniz..."
                      onIonChange={(e) => setKullanimSekli(e.detail.value)}
                    >
                      {kullanimSekilleri &&
                        kullanimSekilleri.map((val: BinaKullanimSekli, i) => (
                          <IonSelectOption key={i} value={val.id}>
                            {val.tanim}
                          </IonSelectOption>
                        ))}
                    </IonSelect>
                  </IonItem>
                </IonCol>
              </IonRow>
              {kullanimSekliMessage && (
                <IonRow>
                  <IonCol size="8" offset="4">
                    <IonText color="danger ion-padding-start">
                      {kullanimSekliMessage}
                    </IonText>
                  </IonCol>
                </IonRow>
              )}
              <IonRow>
                <IonCol
                  size="4"
                  offset="0"
                  sizeSm="3"
                  offsetSm="1"
                  className="ion-hide-sm-down"
                >
                  <IonItem className="ion-text-end">
                    <IonLabel>İnşaat Sınıfı</IonLabel>
                  </IonItem>
                </IonCol>
                <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                  <IonItem className="ion-hide-sm-up">
                    <IonLabel position="floating">İnşaat Sınıfı</IonLabel>
                    <IonSelect
                      name="insaatSinifiIdInput"
                      interface="popover"
                      value={insaatSinifiId}
                      onIonChange={(e) => setInsaatSinifi(e.detail.value)}
                    >
                      {insaatSiniflari &&
                        insaatSiniflari.map((val: BinaInsaatSinif, i) => (
                          <IonSelectOption key={i} value={val.id}>
                            {val.tanim}
                          </IonSelectOption>
                        ))}
                    </IonSelect>
                  </IonItem>
                  <IonItem className="ion-hide-sm-down">
                    <IonSelect
                      name="insaatSinifiIdInput"
                      interface="popover"
                      value={insaatSinifiId}
                      onIonChange={(e) => setInsaatSinifi(e.detail.value)}
                      placeholder="Seçiniz..."
                    >
                      {insaatSiniflari &&
                        insaatSiniflari.map((val: BinaInsaatSinif, i) => (
                          <IonSelectOption key={i} value={val.id}>
                            {val.tanim}
                          </IonSelectOption>
                        ))}
                    </IonSelect>
                  </IonItem>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol style={{ textAlign: "center" }}>
                  <IonButton type="submit">Sorgula</IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
            <IonCard>
              <IonCardContent className="datatable-responsive">
                {loading && (
                  <DataTable
                    value={loadingData}
                    paginator
                    rows={10}
                    removableSort
                    stripedRows
                    size="small"
                    responsiveLayout="stack"
                    breakpoint="960px"
                  >
                    <Column
                      field="kullanimSekli"
                      header="Kullanım Şekli"
                      body={loadingBodyTemplate}
                      sortable
                      headerClassName="ion-text-center"
                    ></Column>
                    <Column
                      field="insaatSinifi"
                      header="İnşaat Sınıfı"
                      body={loadingBodyTemplate}
                      sortable
                      headerClassName="ion-text-center"
                    ></Column>
                    <Column
                      field="insaatTuru"
                      header="İnşaat Türü"
                      body={loadingBodyTemplate}
                      sortable
                      headerClassName="ion-text-center"
                    ></Column>
                    <Column
                      field="maliyetBedeli"
                      header="Maliyet Bedeli"
                      body={loadingBodyTemplate}
                      sortable
                      headerClassName="ion-text-center"
                      bodyClassName="p-column-content-currency"
                      style={{ width: "20%" }}
                    ></Column>
                  </DataTable>
                )}
                {!loading && (
                  <DataTable
                    value={sonuc}
                    paginator
                    rows={10}
                    removableSort
                    footer={footer}
                    ref={dt}
                    stripedRows
                    size="small"
                    responsiveLayout="stack"
                    breakpoint="960px"
                  >
                    <Column
                      field="kullanimSekli"
                      header="Kullanım Şekli"
                      sortable
                      headerClassName="ion-text-center"
                      body={kullanimSekliBodyTemplate}
                    ></Column>
                    <Column
                      field="insaatSinifi"
                      header="İnşaat Sınıfı"
                      sortable
                      headerClassName="ion-text-center"
                      body={insaatSinifiBodyTemplate}
                    ></Column>
                    <Column
                      field="insaatTuru"
                      header="İnşaat Türü"
                      sortable
                      headerClassName="ion-text-center"
                      body={insaatTuruBodyTemplate}
                    ></Column>
                    <Column
                      field="maliyetBedeli"
                      header="Maliyet Bedeli"
                      sortable
                      body={degerBodyTemplate}
                      headerClassName="ion-text-center"
                      bodyClassName="p-column-content-currency"
                      style={{ width: "20%" }}
                    ></Column>
                  </DataTable>
                )}
              </IonCardContent>
            </IonCard>
          </form>
        </IonContent>
      </IonContent>
    </IonPage>
  );
};

export default BinaDegerSorgu;
